import { Button } from '@curology/ui-components-web/react/Button';
import { ErrorIcon } from '@curology/ui-components-web/react/Icon/icons/ErrorIcon';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { ModalFooter } from '@curology/ui-components-web/react/Modal/ModalFooter';
import { ModalHeader } from '@curology/ui-components-web/react/Modal/ModalHeader';
import { useAtom } from 'jotai';
import React from 'react';

import { FlashMessagesState } from '@/atoms/flashMessages/flashMessagesState';
import SelectAndRegisterPaymentMethodForm from '@/components/payments/components/SelectAndRegisterPaymentMethodForm';
import { PAYMENT_METHODS } from '@/components/product-selection/consts/paymentMethods';
import { CHECKOUT_CONTEXT } from '@/consts/checkout';
import { type PaymentMethod } from '@/services/resubscriptionService/types';
import { type PaymentInvoice } from '@/types/payments/types';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

const PaymentMethodModal: React.FC<{
  paymentInvoice: PaymentInvoice;
  setPaymentMethod: React.Dispatch<React.SetStateAction<PaymentMethod | null>>;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
}> = ({ paymentInvoice, setPaymentMethod, setShowModal, showModal }) => {
  const [flashMessages, setFlashMessages] = useAtom(
    FlashMessagesState.flashMessagesAtom,
  );

  const flashError = (message: string) =>
    setFlashMessages([
      ...flashMessages,
      {
        children: message,
        icon: <ErrorIcon />,
        iconSize: 'sm',
        state: 'critical',
        title: 'Whoops!',
      },
    ]);

  const onRegisteredPayment = (newPaymentMethod: PaymentMethod) => {
    setPaymentMethod(newPaymentMethod);
    setShowModal(false);
    trackEvent(AnalyticsEvent.RESUBSCRIBE_INFORMATION_UPDATED, {
      moduleName: 'payment',
    });
  };

  return (
    <Modal
      onClose={() => setShowModal(false)}
      open={showModal}
      title={<ModalHeader>Payment Method</ModalHeader>}
      type="light"
      contentStyle="card"
      width={576}
    >
      <ModalContent className="cur-p-4 cur cur-text-center">
        <SelectAndRegisterPaymentMethodForm
          paymentInvoice={paymentInvoice}
          onSuccess={onRegisteredPayment}
          onError={flashError}
          checkoutContext={CHECKOUT_CONTEXT.TreatmentRenewal}
          initialSelection={PAYMENT_METHODS.cc}
        />
      </ModalContent>
      <ModalFooter>
        <Button
          className="cur-w-full"
          data-sentry-id="Close modal"
          onClick={() => setShowModal(false)}
          size="lg"
          buttonType="secondary"
        >
          Back
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PaymentMethodModal;
